export const eventPhoneCall = () => {};

export const eventWhatsApp = () => {};

export const eventViber = () => {};
